import React, { useState, useEffect } from "react";
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Interactive from "./components/Interactive";
import Landing from "./components/Landing"
import ArticleGrid from "./components/ArticleGrid";
import Blurb from "./components/Blurb";

function App() {
  const [ data, setData ] = useState(null);
  
  useEffect(() => {
		fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/march-madness-2024")
		.then(res => res.json())
		.then(res => setData(res.data['article.aml']))
  }, [])

  return data && (
    <div className="App" style={{backgroundColor:"#0864bb"}}>
      <Header/>
      <Landing data={data}></Landing>
      <Blurb data={data}></Blurb>
      <ArticleGrid articles={data.articles} />
      <Footer/>
    </div>
  );
}

export default App;
